import { FormLayout } from "@shopify/polaris"
import { ExternalLabel } from "components/widgets/CollectPage/forms/fields/CollectFields"
import Form from "components/widgets/CollectPage/forms/Form"
import React from "react"
import { useTranslation } from "react-i18next"
import { useFormConfig } from "../../FormContext"
import { Module } from "../../Module"
import AiServicesInventory from "components/widgets/CollectPage/forms/inventories/environment/AiServicesInventory"
import { AI_SERVICES_COLLECT_MODULE } from "utils/constants/collects/modules"
import { useCollectContext } from "components/widgets/CollectPage/CollectContextProvider"
import { useAppContext } from "components/AppContext"
import UploadOrganism from "views/organisms/upload/UploadOrganism"
import CentralizedUploadMolecule from "views/molecules/upload/CentralizedUploadMolecule"
import ExternalUploadMolecule from "views/molecules/upload/worplace/ExternalUploadMolecule"
import TemplateFileLinkMolecule from "views/molecules/files/TemplateFileLinkMolecule"
import ModalAiServiceChoice, {
  INVENTORY_CHOICE,
} from "views/molecules/collects/ai_inventories/ModalAiServiceChoice"

const fields = [
  "env_collect_id",
  "project_name",
  "use_case_name",
  "use_case_type",
  "use_case_goal",
  "personae",
  "provider",
  "model",
  "active_parameters_b",
  "total_parameters_b",
  "output_completion_tokens",
  "weekly_users",
  "weekly_usage",
  "country_location",
  "example_prompts",
  "status",
  "ai_service_source",
  "source",
  "duplicated_from_id",
]

const translationPath = "13.ai_services"

const Objective13AiServicesForm = () => {
  const { t } = useTranslation()
  const { collect } = useCollectContext()
  const { subscription } = useAppContext()

  useFormConfig({ fields, translationPath })

  const isAiServicesCentralized = !!collect?.centralization?.ai_services
  const hasAiServicesFeature = !!subscription?.features?.env_ai_services

  if (!collect) return null

  return (
    <Form>
      <FormLayout>
        <div className="columns">
          <div className="column">
            <FormLayout>
              <Module module={AI_SERVICES_COLLECT_MODULE}>
                <div className="icon-text-lined">
                  <ExternalLabel translationPathName="ai_services_inventory_file" />
                  {!isAiServicesCentralized && <ModalAiServiceChoice />}
                </div>

                {collect?.ai_service_source === INVENTORY_CHOICE ||
                isAiServicesCentralized ? (
                  <UploadOrganism
                    centralisedComponent={
                      <CentralizedUploadMolecule
                        inventoryType={AI_SERVICES_COLLECT_MODULE}
                        displayDownloadIcon
                        templateNameSuffix="ai_services"
                        disabled={!hasAiServicesFeature}
                        canDownloadTemplate={hasAiServicesFeature}
                      />
                    }
                    decentralisedComponent={
                      <ExternalUploadMolecule
                        fileIdExternal="decentralized_inventory_ai_services"
                        fileId="decentralized_inventory_ai_services"
                        inventoryType={AI_SERVICES_COLLECT_MODULE}
                        title={t(
                          "collect:questions.13.ai_services.ai_services_inventory_file.label"
                        )}
                        precision={t(
                          "collect:questions.13.ai_services.ai_services_inventory_file.precision"
                        )}
                        displayDownloadIcon
                        disabled={!hasAiServicesFeature}
                        canDownloadTemplate={hasAiServicesFeature}
                        templateSelectionComponent={
                          <TemplateFileLinkMolecule id="inventory_template_local_ai_services" />
                        }
                      />
                    }
                  />
                ) : (
                  <AiServicesInventory canAddService={hasAiServicesFeature} />
                )}
              </Module>
            </FormLayout>
          </div>
        </div>
      </FormLayout>
    </Form>
  )
}

export default Objective13AiServicesForm
